/* Tamarind theme interactions: header, mobile menu, reveal, accordion, filters, video */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  if (designMode) root.classList.add('shopify-design-mode');

  /* Header: shrink on scroll + floating WhatsApp visibility ------------ */
  function initScrollState() {
    var header = document.querySelector('[data-header]');
    var wa = document.querySelector('.wa-float');
    var ticking = false;
    function update() {
      var y = window.scrollY || window.pageYOffset;
      if (header) header.classList.toggle('is-scrolled', y > 24);
      if (wa) wa.classList.toggle('is-visible', y > 420);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* Mobile menu -------------------------------------------------------- */
  function initNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav]');
    if (!toggle || !nav) return;
    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      nav.classList.toggle('is-open', open);
    }
    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) { setOpen(false); toggle.focus(); }
    });
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 1099) setOpen(false);
    });
  }

  /* Scroll reveal ------------------------------------------------------ */
  function initReveal(scope) {
    var settingOn = document.body.getAttribute('data-reveal-enabled') !== 'false';
    if (!settingOn || reduceMotion || designMode || !('IntersectionObserver' in window)) return;
    root.classList.add('js-reveal');
    var items = (scope || document).querySelectorAll('[data-reveal]:not(.is-in)');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Accordion with smooth open/close ----------------------------------- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('[data-accordion]').forEach(function (list) {
      if (list.dataset.bound) return;
      list.dataset.bound = '1';
      var single = list.hasAttribute('data-single');
      list.querySelectorAll('details').forEach(function (item) {
        var summary = item.querySelector('summary');
        summary.addEventListener('click', function (e) {
          if (reduceMotion) {
            if (single && !item.open) closeOthers(list, item);
            return;
          }
          e.preventDefault();
          if (item.open) {
            item.classList.add('is-closing');
            setTimeout(function () { item.open = false; item.classList.remove('is-closing'); }, 380);
          } else {
            if (single) closeOthers(list, item);
            item.classList.add('is-opening');
            item.open = true;
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { item.classList.remove('is-opening'); });
            });
          }
        });
      });
    });
  }
  function closeOthers(list, keep) {
    list.querySelectorAll('details[open]').forEach(function (d) {
      if (d === keep) return;
      d.classList.add('is-closing');
      setTimeout(function () { d.open = false; d.classList.remove('is-closing'); }, 380);
    });
  }

  /* Service filter tabs ------------------------------------------------ */
  function initFilters(scope) {
    (scope || document).querySelectorAll('[data-filter-root]').forEach(function (rootEl) {
      var tabs = rootEl.querySelectorAll('[data-filter]');
      var cards = rootEl.querySelectorAll('[data-filter-list] [data-tag]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var value = tab.getAttribute('data-filter');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          cards.forEach(function (card) {
            var show = value === 'all' || card.getAttribute('data-tag') === value;
            card.classList.toggle('is-hidden', !show);
            if (show) card.classList.add('is-in');
          });
        });
      });
    });
  }

  /* YouTube / Vimeo click-to-play -------------------------------------- */
  function initVideos(scope) {
    (scope || document).querySelectorAll('[data-video-embed]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-video-embed');
        var iframe = document.createElement('iframe');
        iframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.setAttribute('allowfullscreen', '');
        iframe.title = btn.getAttribute('aria-label') || 'Video';
        btn.replaceWith(iframe);
      }, { once: true });
    });
  }

  function initAll(scope) {
    initAccordions(scope);
    initFilters(scope);
    initVideos(scope);
    initReveal(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScrollState();
    initNav();
    initAll(document);
  });

  /* Re-run when sections change inside the theme editor */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest ? e.target.closest('details') : null;
    if (d) d.open = true;
    var card = e.target.closest ? e.target.closest('[data-tag]') : null;
    if (card) card.classList.remove('is-hidden');
  });
})();
